import gql from 'graphql-tag';

const GET_AUDIENCE_COUNT = gql`
  query getAudienceCount($metric: JSON!) {
    getAudienceCount(metric: $metric)
  }
`;

export default GET_AUDIENCE_COUNT;
